/** Billing is on: the server templates "on" here only with the billing routes mounted
 * (web/index.html). Off, the account menu has no Billing and neither Unlock button shows. */
export const billingOn =
  document.querySelector('meta[name="featurette-billing"]')?.getAttribute("content") === "on";
